import { ExperienceSLOKeys, PerformanceSLOKeys, RouteSLOKeys } from "./slo-declarations";
export { ExperienceSLOKeys, PerformanceSLOKeys, RouteSLOKeys } from "./slo-declarations";

export type ExperienceSLOKey = (typeof ExperienceSLOKeys)[keyof typeof ExperienceSLOKeys];
export type PerformanceSLOKey = (typeof PerformanceSLOKeys)[keyof typeof PerformanceSLOKeys];
export type RouteSLOKey = (typeof RouteSLOKeys)[keyof typeof RouteSLOKeys];
